class AdministratorsEndpointsVO {
  private _baseURL({ origin = env.VITE_AMMINISTRO_API_GATEWAY, v = 'v2' }: { origin?: string; v?: string }) {
    return `${origin}/api/${v}`;
  }

  findOneEmailToTicket({ v }: { v?: string }) {
    return `${this._baseURL({ v })}/organizations/own/email-to-ticket-address`;
  }

  findOrganization({ v, id }: { v?: string; id: string }) {
    return `${this._baseURL({ v })}/organizations/${id}`;
  }
}

const administratorsEndpointsVO = new AdministratorsEndpointsVO();

export { administratorsEndpointsVO };
